<template>
  <div class="user">
    <!-- 搜索区域 -->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        
        <Batch :isBatch="isBatch" :excludeIds="excludeIds" :choose_supply_id="choose_supply_id" :islist="islist" @closeDialog="closeDialogFuncBatch"></Batch>


        <div class="common-form">盘点清单</div>   


              
        <div class="common-seach-wrap">
        <el-form :inline="true" size="small" :model="formInline_batch" class="demo-form-inline">
 
      
          <el-form-item label="出货渠道名称">
            <el-input placeholder="请输入出货渠道名称" v-model="formInline_batch.search">
              
            </el-input>
          </el-form-item>

          <el-form-item >
            <el-button  icon="el-icon-search" @click="getBData">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
  
      <!--内容-->
      <div class="product-content">
        <div class="table-wrap">
          <el-table size="small" :data="batchData" border style="width: 100%" highlight-current-row v-loading="loading"
           @selection-change="tableCurrentChange">
           <el-table-column prop="supply_id" label="出货渠道ID"></el-table-column>
           <el-table-column prop="kmdGrade.name" label="角色"></el-table-column>
            <el-table-column prop="name" label="出货渠道名称"></el-table-column>
            <!-- <el-table-column prop="num" label="商品种类"></el-table-column> -->
         
            <el-table-column width="80" label="单选">
              <template slot-scope="scope">
                <el-button size="mini" @click="selectB(scope.row)">选择</el-button>

                <!-- <el-button size="mini" @click="exportB(scope.row)">导出</el-button> -->
       
              </template>
            </el-table-column>
          </el-table>
        </div>
  
        <!--分页-->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage_batch"
            :page-sizes="[2, 10, 20, 50, 100]"
            :page-size="pageSize_batch"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber_batch"
          ></el-pagination>
        </div>
      </div>



        <el-button icon="el-icon-plus"  @click="changeProduct(form.product)">选择商品</el-button>
        <el-table size="small" :data="form.product"   border style="width: 100%" v-loading="loading">

          <el-table-column prop="product_name" label="商品"></el-table-column>
          <el-table-column prop="spec_value" label="规格"></el-table-column>
          <el-table-column prop="unit" label="计量单位"></el-table-column>


        <el-table-column prop="purchasePrice" label="进货价"></el-table-column>
        <el-table-column prop="product_price" label="销售价"></el-table-column>
          <el-table-column prop="act_stock" label="现有库存"></el-table-column>
          <el-table-column prop="rk_stock" label="入库库存"></el-table-column>
          <el-table-column prop="ck_stock" label="出库库存"></el-table-column>

          <el-table-column prop="theoretical_qty" label="理论库存">
              <template #default="scope">
                {{ scope.row.rk_stock - scope.row.ck_stock }}
              </template>

            </el-table-column>

          <el-table-column prop="act_num" label="线下实际库存">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.act_num"
                placeholder="请输入线下实际库存"
                type="number"
              ></el-input>

        

            </template>
          </el-table-column>


          
          <el-table-column prop="actual_price" label="线下实际进货价">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.actual_price"
                placeholder="线下实际进货价"
                type="number"
              ></el-input>

        

            </template>
          </el-table-column>

          <el-table-column prop="act_num" label="库存差">
            <template slot-scope="scope">
              {{ scope.row.act_num -  scope.row.act_stock}}

        

            </template>
          </el-table-column>


          <el-table-column prop="act_num" label="金额差">
            <template slot-scope="scope">
              {{ (scope.row.purchasePrice -  scope.row.actual_price).toFixed(2)}}

        

            </template>
          </el-table-column>

          <el-table-column prop="warehousekwtext" label="库区"></el-table-column>
          <el-table-column prop="rk.rk_text" label="入库状态">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="del(scope.$index)" size="mini">删除</el-button>
            </template>
          </el-table-column>

        </el-table>


        <el-form-item>
          <el-button type="primary" icon="el-icon"
          v-auth="'/plus/warehouse_inventory/index/calculateInventory'"
          @click="calculateInventory">盘点库存</el-button>


          <el-button type="primary" icon="el-icon"
          
          @click="plClick">批量盘点库存</el-button>
        </el-form-item>
      </el-form>
    </div>


    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
    
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <!-- 显示盘点记录 -->
    <div class="product-content">
      <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
        <el-table-column prop="warehouse_kw_id" label="仓库编号" width="60" />
        <el-table-column prop="product_id" label="商品编号" width="60" />
        <el-table-column prop="productName" label="产品名称" >

          <template #default="scope">
              <div>
                {{ scope.row.productName }}-{{ scope.row.productSpecification }}
              </div>
              <div>
                分类：{{ scope.row.productCategory }}
              </div>
              <div>
                单位：{{ scope.row.salesUnit }}
              </div>


          </template>

        </el-table-column>

        <el-table-column prop="purchasePrice" label="进货价"  width="60" />
        <el-table-column prop="product_price" label="销售价"  width="60" />

        <el-table-column prop="rk_stock" label="入库库存"  width="60"/>
          <el-table-column prop="ck_stock" label="出库库存"  width="60"/>
        <el-table-column prop="theoretical_qty" label="理论库存"  width="60" />
        <el-table-column prop="theoretical_qty" label="理论实际库存" >
          <template #default="scope">
              {{ scope.row.rk_stock - scope.row.ck_stock }}
          </template>
        </el-table-column>
        <el-table-column prop="actual_qty" label="线下实际库存">
        </el-table-column>
        <el-table-column prop="actual_price" label="线下实际进货价">
        </el-table-column>
        <el-table-column prop="difference" label="差异数量" />
        <el-table-column prop="difference_price" label="差异金额"></el-table-column>
        <!-- <el-table-column prop="remark" label="备注">
          <template #default="scope">
            <el-input v-model="scope.row.remark" placeholder="备注" size="small" />
          </template>
        </el-table-column> -->
        <el-table-column prop="shop_user_text" label="操作人"   width="60"/>
        <el-table-column label="操作" width="160" fixed="right">
          <template #default="scope">
            <el-input v-model="scope.row.remark" placeholder="备注" size="small"  style="margin-bottom: 20px;" />
           
            <el-button  type="primary" v-if="scope.row.status == 0" 
              size="small" v-auth="'/plus/warehouse_inventory/index/confirmInventory'"  @click="confirmInventory(scope.row)">确认</el-button>
            <el-button   size="small" v-if="scope.row.status == 0" v-auth="'/plus/warehouse_inventory/index/del'" @click="deleteClick(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
          <!-- 上传导入组件  -->
          <Upload v-if="open_upload" @closeDialog="closeDialogFunc($event,'upload')"></Upload>

  </div>
</template>

<script>
  import PorductApi from '@/api/product.js';
import Warehouse_inventoryApi from '@/api/warehouse_inventory.js';
import Batch from '@/components/product/batch';
import {mergeTable} from '@/utils/table.js';
import Upload from '@/components/file/import';
export default {
  components: {
     Batch,
     Upload
  },
  data() {
    return {
      loading: false,
  
      isBatch:false,
      islist:true,
      form:{
        product:[]
      },
      excludeIds:[],


      formInline: {
          search:""
        },

       /*列表数据*/
                tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
       
        open_upload:false,
        // 导入类型
        import_type:'warehouse_inventory',

        batchData:[],
        formInline_batch:{
            search_batch:"",
        
 

        },
            /*当前是第几页*/
            curPage_batch: 1,
        /*一页多少条*/
        pageSize_batch: 10,
        totalDataNumber_batch:0,

        choose_supply_id:0,
        multipleSelection:[]
    };
  },
  created() {
    this.getBData();
          /*获取列表*/
          this.getTableList();
  },
  methods: {
             /*获取商品列表*/
             getBData() {
        console.log("走了吗")
        let self = this;
        let params = self.formInline_batch;
        params.page = self.curPage_batch;
        params.list_rows = self.pageSize_batch;
        PorductApi.getBatch(params, true)
          .then(res => {
            if (res.code == 1) {
              self.loading = false;
              self.batchData = res.data.list.data;
              self.totalDataNumber_batch = res.data.list.total;
            }
          })
          .catch(error => {});
      },

      selectB(row){
        // this.supply_id = row.supply_id
        // console.log('row.supply_id',row.supply_id);
        this.choose_supply_id =  row.supply_id
        // this.getData()
      },
        /*监听复选按钮选中事件*/
        tableCurrentChange(val) {
      this.multipleSelection = val;
    },


    plClick(){
        this.open_upload = true
      },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
        if (f == 'upload') {
          this.open_upload = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        Warehouse_inventoryApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },



    del(ind){
      this.form.product.splice(ind,1);
    },
    closeDialogFuncBatch(e){
      console.log('e.params',e.params)
      let self = this;
      self.isBatch = false;
      if (e.type === 'success') {
        let arr = [];
        for (let i = 0; i < e.params.length; i++) {
          let item = e.params[i];
          let obj = {
            product_name: item.product_name,
            product_id: item.product_id,
            product_sku_id: item.product_sku_id,
            product_price: item.product_price,
            product_image: item.product_image,
            warehouse_kw_id: item.warehouse_kw_id,
            warehousekwtext: item.warehousekwtext,
            warehousetext: item.warehousetext,
            unit: item.unit,
            spec_value:item.spec_value,
            status:0,//0 未入库 1  已入库
            set_num:1,
            file_path:item.image.file_path,
            rk:item.warehouse_management,
            category_name:item.category_name,
            batchNumber:item.batchNumber,
            rk_stock:item.rk_stock,
            ck_stock:item.ck_stock,
            act_stock:item.act_stock,
            act_num:item.rk_stock-item.ck_stock,
            purchasePrice:item.purchasePrice,
          };
          arr.push(obj)
        }
        self.form.product = self.form.product.concat(arr);
        self.form.product = mergeTable(this.form.product);

    }
  },
      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Warehouse_inventoryApi.del(
              {
                warehouse_inventory_id: row.warehouse_inventory_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
  
   /*打开添加*/
   changeProduct(list) {
    if(this.choose_supply_id <= 0){
        this.$message.error("请选择批发点");
        return;
      }
      let arr = [];
      list.forEach(item => {
        arr.push(item.product_sku_id);
      });
      this.excludeIds = arr;
      this.isBatch = true;
    },

    // 盘点库存
   calculateInventory() {
     var self = this;
      if (self.form.product.length <= 0) {
        self.$message.warning("请选择盘点商品");
        return;
      }
      self.loading = true;
      var params = {
        'parmas':JSON.stringify(self.form.product),
      }
      try {
        
    
          Warehouse_inventoryApi.calculateInventory(params, true)
            .then(res => {
              self.$message.success(res.msg || "盘点成功");
              self.getTableList();
              self.form.product = [];
            })

      } catch (err) {
        this.$message.error("盘点失败");
      } finally {
        this.loading = false;
      }
    },
    // 确认盘点
    confirmInventory(row) {
      var self = this;
      self.loading = true;
      var params = {
        warehouse_inventory_id:row.warehouse_inventory_id,
        remark:row.remark,
      }
      try {
        self
          .$confirm('确认后会修改当前现有商品的进货价，库存, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Warehouse_inventoryApi.confirmInventory(params, true)
              .then(res => {
                self.$message.success(res.msg || "确认盘点成功");
                self.getTableList();
              })

          })





      } catch (err) {
        this.$message.error("确认盘点失败");
        self.getTableList();
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/plus/warehouse_inventory/index/index.vue